import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setGuestsSplitiing } from '../../../actions/checkout-la-actions'
import useTrip from './useTrip'

export default function useUpdateShared() {
  const [newOccupancy, setNewOccupancy] = useState({})
  const { selectedTrip } = useTrip()
  const dispatch = useDispatch()

  const guestsSplitting = useSelector(({ guestsSplitting }) => guestsSplitting)

  function updateShared(cabin, isNoUpdate, isShared) {
    const newSplitting = guestsSplitting.reduce((newSplitting, split) => {
      const id = cabin?.room?.roomCategory?.id
      if(id !== split.id) {
        return [...newSplitting, split]
      }
      const cabinPackage = selectedTrip?.packages?.find(
        (el) => el.roomCategory.id === id,
      )
      const occupancy = cabinPackage?.prices?.find((el) => {
        return (
          el.isShared === isShared &&
          el.numberOfInstances === 1 &&
          el.isDiver === cabin?.items[0]?.isDiver
        )
      })
      const restPricing = split.pricing.filter(
        (pricing) => pricing.id !== cabin?.items[0].id,
      )

      setNewOccupancy(occupancy)

      if(!isNoUpdate) {
        split.cart.forEach((el) => {
          el.forEach((item, index) => {
            if(item.id === cabin?.items[0]?.id) {
              el[index] = {
                ...occupancy,
                qty: cabin?.items[0]?.qty,
                upgraded: !isShared,
              }
            }
          })
        })
      }

      return [
        ...newSplitting,
        {
          ...split,
          pricing: [
            ...restPricing,
            { ...occupancy, qty: cabin?.items[0]?.qty, upgraded: !isShared },
          ],
        },
      ]
    }, [])

    if(isNoUpdate) {
      return
    }

    dispatch(setGuestsSplitiing([...newSplitting]))
  }

  return { updateShared, newOccupancy }
}
